import React from 'react';
import { IStyledSVGIconProps, StyledSVGIcon } from './icon.style';

export const EmptyIcon: React.FC<IStyledSVGIconProps> = (props) => {
  return (
    <StyledSVGIcon
      version="1.1"
      id="icons"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 87 24"
      {...props}
    >
      <rect x="32" y="18" width="55" height="6" rx="2"/>
      <rect x="32" width="55" height="14" rx="2"/>
      <rect width="24" height="24" rx="2"/>
    </StyledSVGIcon>
  );
};